<template>
  <base-notification-item-contents-parts
    class="notification-item-contents-parts"
    :notification="notification"
    @handlerClickLink="$emit('handlerClickLink', notification)"
  >
    <div class="notification-item-contents-parts__thumbnail" v-if="notification.thumbnail">
      <img :src="notification.thumbnail" alt="" />
      <svg
        class="notification-item-contents-parts__play-icon"
        v-if="notification.mediaType === 'video'"
        width="48"
        height="49"
        viewBox="0 0 48 49"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.7">
          <path
            d="M9 6.27051L37.9011 22.5274C39.2604 23.292 39.2604 25.2491 37.9011 26.0137L9 42.2705V6.27051Z"
            fill="white"
          />
        </g>
      </svg>
    </div>
  </base-notification-item-contents-parts>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import { NotificationItemType } from '@/components/NotificationPane/NotificationPane.vue'
import BaseNotificationItemContentsParts from '@/components/NotificationPane/NotificationPane/parts/BaseNotificationItemContentsParts.vue'

/**
 * Notification 詳細アイテム: TYPE = 通知 コンポーネント
 */
export default defineComponent({
  name: 'NotificationItemContentsParts',
  components: {
    BaseNotificationItemContentsParts,
  },
  props: {
    notification: {
      type: Object as PropType<NotificationItemType>,
      required: true,
    },
  },
})
</script>

<style lang="scss" scoped>
.notification-item-contents-parts {
  &__thumbnail {
    position: relative;
    width: 100%;
    margin-top: 12px;

    img {
      width: 100%;
      height: auto;
      border-radius: 8px;
    }
  }

  &__play-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: max(13.994169%, 48px);
  }
}
</style>
